function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "man-laptop-v1");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.9996918%",
  y1: "99.9979689%",
  x2: "49.9996918%",
  y2: "0.00240706678%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#76AADB",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4A72B2",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "1.37163792e-14%",
  y1: "49.9877232%",
  x2: "100%",
  y2: "49.9877232%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ACAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ADFC3",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "-2838.69509%",
  x2: "100%",
  y2: "-2838.69509%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ACAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ADFC3",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.0397675%",
  x2: "99.9881503%",
  y2: "50.0397675%",
  id: "linearGradient-4"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7F7F8",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "-2231.98087%",
  x2: "100%",
  y2: "-2231.98087%",
  id: "linearGradient-5"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7F7F8",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-0.00110556171%",
  y1: "241.326809%",
  x2: "99.9860863%",
  y2: "241.326809%",
  id: "linearGradient-6"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ACAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ADFC3",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-0.00940329686%",
  y1: "570.503162%",
  x2: "99.9963569%",
  y2: "570.503162%",
  id: "linearGradient-7"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ACAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ADFC3",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0.353973066%",
  y1: "775.603996%",
  x2: "100.501238%",
  y2: "775.603996%",
  id: "linearGradient-8"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ACAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2ADFC3",
  offset: "100%"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "man-laptop-v1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M117.16,302.28 C117.16,302.28 29.23,241.43 117.16,158.38 C205.09,75.33 307.24,27 371.07,24.19 C434.9,21.38 444.84,174.55 406.53,275.28 C368.22,376.01 237.73,393 117.16,302.28 Z",
  id: "_Path_",
  fill: "url(#linearGradient-1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.8,202.22 C312.8,202.22 354.03,252.44 302.9,284.91 L294.9,268.46 C294.9,268.46 312.55,250.08 299.47,227.66 L312.8,202.22 Z",
  id: "_Path_2",
  fill: "#FFCB9C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.15,202.22 C130.15,202.22 88.92,252.44 140.05,284.91 L148.05,268.46 C148.05,268.46 130.4,250.08 143.48,227.66 L130.15,202.22 Z",
  id: "_Path_3",
  fill: "#FFCB9C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M322.29,212.84 C301.29,171.05 262.1,164.84 262.1,164.84 L262.1,165.1 L249.6,162 C223.215092,156.380396 195.850215,157.369737 169.94,164.88 C169.94,164.88 131.6,175.11 115.08,218.88 L139.08,231.98 C137.08,252.76 137.59,278.74 142.82,310.98 C155.15,307.06 169.12,312.24 181.95,313.05 C197.19,314.05 210.84,312.43 225.85,314.65 C253.12,318.65 280.95,316.88 308.43,319.01 C308.81,294.46 307.7,259.91 300.92,227.6 L322.29,212.84 Z",
  id: "_Path_4",
  fill: "url(#linearGradient-2)"
}), /*#__PURE__*/React.createElement("g", {
  id: "_Group_2",
  transform: "translate(179.000000, 53.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.88,56.91 C88.28,71.14 84.73,84.01 63.38,93.6 C63.38,93.6 52.38,104.6 55.62,119.73 C58.86,134.86 17.52,133.73 23.69,112.81 C29.86,91.89 19.62,67.89 12.12,54.23 C4.62,40.57 7.74,12 25,2.78 C31.77,-0.86 48.63,0.78 59.63,6.24 C78.13,15.32 89.75,36.29 88.88,56.91 Z",
  id: "_Path_5",
  fill: "#FFCB9C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.38,42 C13.1854395,39.5912325 9.09440155,38.7064861 5.19,39.58 C-0.99,41.19 -2.06,63.82 12.41,67.77 C26.88,71.72 21.7,57.52 21.7,57.52 L16.38,42 Z",
  id: "_Path_6",
  fill: "#FFCB9C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.63,54.49 C89.0534287,54.5697638 88.4720624,54.609858 87.89,54.61 C86.7507248,54.6221538 85.6177508,54.4395251 84.54,54.07 C79.7,56.49 71.46,59.14 63.29,54.9 C50.65,48.32 39.44,47.35 33.54,50.23 C23.37,55.23 11.74,52.51 8.29,36.84 C8.29,36.84 6.87,49.31 14.58,55.84 C22.29,62.37 22.58,72.69 21.5,81.22 C20.42,89.75 14.28,99.22 22.04,110 C29.8,120.78 42.47,110 52.04,112.57 C61.61,115.14 82.53,117.76 86.91,100.44 C91.29,83.12 85.63,76.64 86.91,69.44 C88,63.4 90.39,59.75 89.63,54.49 Z",
  id: "_Path_7",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("g", {
  id: "_Group_3",
  transform: "translate(46.000000, 59.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_Group_4",
  fill: "#CE3E3E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.79,4 C12.0220791,2.51892294 9.95486144,1.43755659 7.73,0.83 C4.79,0.28 1.73,0.83 0.46,4.47 C-0.81,8.11 2.36,11.47 6.41,14.57 C8.8,16.3 17.41,19.47 22.64,18.03 C27.87,16.59 30.69,15.16 32.34,12.09 C33.99,9.02 31.97,5.16 29.57,3.85 C27.4467888,2.80736431 24.9475162,2.87087348 22.88,4.02 C20.1092914,5.80003743 16.5528488,5.79221248 13.79,4 Z",
  id: "_Path_8"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Group_5",
  transform: "translate(2.000000, 10.000000)",
  fill: "#FF7D7D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.4,0.9 C3.47120047,-0.0863029462 6.78175956,-0.033587037 9.82,1.05 C13.7241961,2.17156094 17.0515355,4.74398789 19.12,8.24 C14.8710405,8.52765221 10.6192273,7.7220455 6.77,5.9 C4.26967846,4.77941798 2.08242678,3.06257993 0.4,0.9 Z",
  id: "_Path_9"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M52,34.69 C52,37.17 51,39.18 49.68,39.18 C48.36,39.18 47.36,37.18 47.36,34.69 C47.36,32.2 48.36,30.23 49.68,30.23 C51,30.23 52,32.22 52,34.69 Z",
  id: "_Path_10",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.28,37.59 C77.28,40.06 76.28,42.07 74.96,42.07 C73.64,42.07 72.64,40.07 72.64,37.59 C72.64,35.11 73.64,33.12 74.96,33.12 C76.28,33.12 77.28,35.13 77.28,37.59 Z",
  id: "_Path_11",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("circle", {
  id: "_Path_12",
  stroke: "#1D1D1B",
  strokeWidth: 2,
  transform: "translate(78.906087, 34.722280) rotate(-7.000000) translate(-78.906087, -34.722280) ",
  cx: 78.9060874,
  cy: 34.7222799,
  r: 14.27
}), /*#__PURE__*/React.createElement("polygon", {
  id: "_Path_13",
  fill: "#FF6252",
  points: "65.06 22.62 72.6 52.56 57.07 50.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.7,32.41 C61.7,40.2911034 55.3111034,46.68 47.43,46.68 C39.5488966,46.68 33.16,40.2911034 33.16,32.41 C33.16,24.5288966 39.5488966,18.14 47.43,18.14 C51.2146393,18.14 54.8442696,19.6434421 57.5204138,22.3195862 C60.1965579,24.9957304 61.7,28.6253607 61.7,32.41 Z",
  id: "_Path_14",
  stroke: "#1D1D1B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.22,25.26 L59.67,25.26",
  id: "_Path_15",
  stroke: "#1D1D1B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.61,28.55 L7.01,36.84",
  id: "_Path_16",
  stroke: "#1D1D1B",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.4,58.64 C21.4040459,61.4438298 19.7181733,63.9738267 17.1289326,65.0496106 C14.539692,66.1253944 11.5573367,65.5349639 9.57329658,63.5537868 C7.58925647,61.5726097 6.99451994,58.5911101 8.06656369,56.0003187 C9.13860745,53.4095273 11.6661673,51.7200029 14.47,51.72 C18.2934315,51.719996 21.3944828,54.8165725 21.4,58.64 Z",
  id: "_Path_17",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.76,66.81 C23.76,70.1237085 21.0737085,72.81 17.76,72.81 C14.4462915,72.81 11.76,70.1237085 11.76,66.81 C11.76,63.4962915 14.4462915,60.81 17.76,60.81 C21.0737085,60.81 23.76,63.4962915 23.76,66.81 Z",
  id: "_Path_18",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.85,76.29 C25.8499975,79.5710983 23.8729757,82.5289292 20.8412485,83.783615 C17.8095213,85.0383007 14.3204825,84.3426087 12.0018274,82.021091 C9.68317225,79.6995734 8.99178559,76.2096788 10.2502109,73.179502 C11.5086362,70.1493252 14.4689042,68.1759543 17.75,68.18 C19.8999873,68.1799984 21.9617709,69.0347613 23.4811034,70.5559695 C25.0004358,72.0771777 25.8526543,74.1400143 25.85,76.29 Z",
  id: "_Path_19",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.85,89.41 C25.8540444,92.6920053 23.8795902,95.6529052 20.8481848,96.9107432 C17.8167794,98.1685812 14.3261001,97.4753598 12.0053702,95.1546298 C9.68464019,92.8338999 8.99141878,89.3432206 10.2492568,86.3118152 C11.5070948,83.2804098 14.4679947,81.3059556 17.75,81.31 C22.2212222,81.3155098 25.8444902,84.9387778 25.85,89.41 Z",
  id: "_Path_20",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5,103.82 C29.5055076,108.292197 25.8855198,111.922611 21.4133251,111.929964 C16.9411303,111.937318 13.3092231,108.318829 13.3000233,103.846638 C13.2908235,99.3744465 16.9078129,95.7410459 21.38,95.73 C23.5246807,95.7246897 25.5834852,96.5722555 27.1028191,98.0859622 C28.622153,99.599669 29.4773523,101.655314 29.48,103.8 L29.5,103.82 Z",
  id: "_Path_21",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.8,112.72 C38.8,117.193506 35.1735065,120.82 30.7,120.82 C26.2264935,120.82 22.6,117.193506 22.6,112.72 C22.6,108.246494 26.2264935,104.62 30.7,104.62 C32.8490673,104.617342 34.9108788,105.469879 36.4305,106.9895 C37.9501213,108.509121 38.8026581,110.570933 38.8,112.72 Z",
  id: "_Path_22",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.27,111.91 C54.2506997,116.354541 50.6371479,119.944631 46.192576,119.934981 C41.748004,119.925331 38.150076,116.319582 38.150076,111.875 C38.150076,107.430418 41.748004,103.824669 46.192576,103.815019 C50.6371479,103.805369 54.2506997,107.395459 54.27,111.84 L54.27,111.91 Z",
  id: "_Path_23",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.52,114.85 C69.5240444,118.132005 67.5495902,121.092905 64.5181848,122.350743 C61.4867794,123.608581 57.9961001,122.91536 55.6753702,120.59463 C53.3546402,118.2739 52.6614188,114.783221 53.9192568,111.751815 C55.1770948,108.72041 58.1379947,106.745956 61.42,106.75 C65.8935065,106.75 69.52,110.376494 69.52,114.85 Z",
  id: "_Path_24",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.83,110.09 C84.8742484,113.370676 82.9374446,116.354815 79.9230829,117.650353 C76.9087211,118.945891 73.4107264,118.297567 71.0608685,116.007815 C68.7110106,113.718063 67.9722862,110.238038 69.1893008,107.191126 C70.4063153,104.144214 73.3392783,102.130754 76.62,102.09 L76.73,102.09 C81.1647433,102.089662 84.7752501,105.655595 84.83,110.09 Z",
  id: "_Path_25",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("circle", {
  id: "_Path_26",
  fill: "#191919",
  cx: 84.17,
  cy: 98.66,
  r: 8.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M97,84.39 C97.0040444,87.6720053 95.0295902,90.6329052 91.9981848,91.8907432 C88.9667794,93.1485812 85.4761001,92.4553598 83.1553702,90.1346298 C80.8346402,87.8138999 80.1414188,84.3232206 81.3992568,81.2918152 C82.6570948,78.2604098 85.6179947,76.2859556 88.9,76.29 C93.3640813,76.2899966 96.984482,79.9059221 96.99,84.37 L97,84.39 Z",
  id: "_Path_27",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.93,70.54 C95.9299975,73.8210983 93.9529757,76.7789292 90.9212485,78.033615 C87.8895213,79.2883007 84.4004825,78.5926087 82.0818274,76.271091 C79.7631722,73.9495734 79.0717856,70.4596788 80.3302109,67.429502 C81.5886362,64.3993252 84.5489042,62.4259543 87.83,62.43 C92.3051236,62.435518 95.9300034,66.064873 95.93,70.54 Z",
  id: "_Path_28",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.33,60.74 C96.6341041,65.2131906 93.2551949,69.0863103 88.7821039,69.3918763 C84.3090129,69.6974424 80.4347891,66.3197993 80.127761,61.8468084 C79.820733,57.3738175 83.1971097,53.49849 87.67,53.19 L88.24,53.19 C92.5615203,53.0439322 96.1833648,56.428499 96.33,60.75 L96.33,60.74 Z",
  id: "_Path_29",
  fill: "#191919"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Group_6",
  transform: "translate(134.000000, 180.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "_Path_30",
  fill: "#AFAFAF",
  x: 2.85,
  y: 118.47,
  width: 177.32,
  height: 8.26,
  rx: 3.84
}), /*#__PURE__*/React.createElement("rect", {
  id: "_Path_31",
  fill: "#D8D8D8",
  x: 0.51,
  y: 0.77,
  width: 182.05,
  height: 122.32,
  rx: 12.48
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.23,61.93 C103.238089,66.7076004 100.366891,71.0194536 95.9556722,72.8543037 C91.5444528,74.6891537 86.462272,73.6855143 83.0797037,70.3115312 C79.6971353,66.937548 78.6805838,61.8579342 80.5042178,57.4420662 C82.3278517,53.0261982 86.6323945,50.1440522 91.41,50.14 C94.5420971,50.1320303 97.5486425,51.3706682 99.7661891,53.5825865 C101.983736,55.7945048 103.23001,58.7978928 103.23,61.93 Z",
  id: "_Path_32",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.94,4.14 L180.24,118.43 C181.456071,116.698338 182.234914,114.69805 182.51,112.6 L182.51,11.85 C182.304079,9.32288993 181.358008,6.91249599 179.79,4.92 C177.928545,2.7222188 175.315466,1.29625493 172.46,0.92 C171.592819,0.833460352 170.721388,0.796733366 169.85,0.81 L12.08,0.81 C9.96357689,0.855019342 7.89549951,1.45131499 6.08,2.54 C5.33626348,3.03141227 4.62172468,3.56564689 3.94,4.14 Z",
  id: "_Path_33",
  fill: "#F5F5F5",
  opacity: 0.57
})), /*#__PURE__*/React.createElement("path", {
  d: "M300.61,331.85 C298.400703,341.776186 295.180568,351.449994 291,360.72 C291,360.72 250.05,366.47 193.7,345.44 C193.7,345.44 167.38,334.03 163.79,331.85 L300.61,331.85 Z",
  id: "_Path_34",
  fill: "#191919"
}), /*#__PURE__*/React.createElement("path", {
  d: "M305.8,331.85 L305.06,337.62 C304.831088,339.431284 303.182645,340.717873 301.37,340.5 L301.23,340.5 C291.48,338.76 262.23,334.69 233.94,339.65 C199.31,345.71 181.42,340.51 181.42,340.51 C181.42,340.51 168.83,334.56 163.79,331.85 L305.8,331.85 Z",
  id: "_Path_35",
  fill: "url(#linearGradient-3)"
}), /*#__PURE__*/React.createElement("g", {
  id: "_Clip_Group_2",
  transform: "translate(123.000000, 306.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.173576294,0.71 L242,0.71 C242,7.65221931 236.372219,13.28 229.43,13.28 L18.829487,13.28 C12.5984043,9.3703333 6.37518284,5.18141253 0.173612351,0.71000022 Z",
  id: "Combined-Shape",
  fill: "url(#linearGradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.829487,13.28 L213.38,13.28 C213.38,20.2222193 207.752219,25.85 200.81,25.85 L40.6891886,25.85 C33.4065621,22.0380698 26.1126546,17.849793 18.829487,13.28 Z",
  id: "Combined-Shape",
  fill: "url(#linearGradient-5)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_Group_7",
  transform: "translate(305.000000, 48.000000)",
  stroke: "#141414"
}, /*#__PURE__*/React.createElement("circle", {
  id: "_Path_38",
  strokeWidth: 3,
  fill: "#FFFFFF",
  cx: 48,
  cy: 47.26,
  r: 47.17
}), /*#__PURE__*/React.createElement("polyline", {
  id: "_Path_39",
  fill: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "47.97 17.17 47.97 47.26 71.52 47.26"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.97,5.34 L47.97,9.37",
  id: "_Path_40",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.22,7.83 L60.86,11.62",
  id: "_Path_41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.8,15.04 L72.2,18.13",
  id: "_Path_42",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.15,26.07 L80.67,28.11",
  id: "_Path_43",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.2,39.62 L85.22,40.37",
  id: "_Path_44",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.34,54.1 L85.34,53.44",
  id: "_Path_45",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.55,67.76 L81.01,65.79",
  id: "_Path_46",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.39,78.97 L72.75,75.92",
  id: "_Path_47",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.97,86.4 L61.53,82.62",
  id: "_Path_48",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.77,89.17 L48.68,85.13",
  id: "_Path_49",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.47,86.93 L35.77,83.11",
  id: "_Path_50",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.77,79.97 L24.3,76.82",
  id: "_Path_51",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.22,69.11 L15.66,67",
  id: "_Path_52",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.9,55.64 L10.87,54.85",
  id: "_Path_53",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5,41.18 L10.5,41.77",
  id: "_Path_54",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.04,27.43 L14.61,29.34",
  id: "_Path_55",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.97,16.06 L22.67,19.07",
  id: "_Path_56",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.25,8.39 L33.77,12.14",
  id: "_Path_57",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Group_8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.6,17.08 C70.0827416,17.7981314 64.6168459,15.4281682 61.37,10.91 C58.48,7 52.61,1.94 43.39,7 C29.54,14.58 27.31,22.57 13.46,25.3 C-0.39,28.03 -3.69,38.71 4.21,46.76 C12.11,54.81 13.46,63.76 9.4,70.88 C5.34,78 3.13,96.35 17.32,97.68 C31.51,99.01 39.83,96.35 43.84,107.52 C47.85,118.69 63.84,132.58 83.34,120.92 C102.84,109.26 122.27,120.46 129.66,119.09 C133.634312,118.392513 137.168202,116.143394 139.482908,112.838279 C141.797614,109.533164 142.703163,105.443312 142,101.47 C142,101.15 141.88,100.84 141.81,100.47 C139.81,90.34 143.16,80.21 150.58,75.47 C150.58,75.47 159.71,72.88 161.93,61.36 C164.15,49.84 162.27,37.36 145.11,31.54 C127.95,25.72 132.71,12.54 117.6,4.84 C102.49,-2.86 91.6,2.42 87.38,7.4 C84,11.36 81.39,16.23 75.6,17.08 Z",
  id: "_Path_58",
  fill: "url(#linearGradient-6)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.72,122 C129.414705,125.999035 125.824848,128.814841 121.63,129.13 C114.29,129.84 114.98,139.99 124.07,138.59 C133.16,137.19 135.62,139.64 138.6,139.99 C141.58,140.34 146.11,139.45 146.48,133.99 C146.85,128.53 142.27,128.92 139.12,128.8 C135.97,128.68 138.95,122.86 137.02,121.11 C136.197902,120.369889 135.115423,119.986744 134.010783,120.044883 C132.906143,120.103022 131.869865,120.597681 131.13,121.42 C130.977426,121.601583 130.840283,121.79559 130.72,122 Z",
  id: "_Path_59",
  fill: "url(#linearGradient-7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.05,147.94 C150.730406,147.032667 149.010308,146.952574 147.61211,147.733358 C146.213913,148.514142 145.379768,150.02058 145.46,151.62 L145.46,152.06 C145.63,157.25 149.99,155.21 152.16,155.52 C154.33,155.83 155.43,153.37 155.43,151.3 C155.43,149.23 153.66,149.49 152.38,148.16 L152.05,147.94 Z",
  id: "_Path_60",
  fill: "url(#linearGradient-8)"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Group_9",
  transform: "translate(46.000000, 25.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.11,64.89 L42.75,64.7 L42.43,57.26 L37.59,57.48 C37.0782425,55.7898124 36.2983076,54.1928027 35.28,52.75 L38.5,49.39 L33.14,44.2 L29.78,47.66 C28.2397446,46.7941641 26.5726105,46.176582 24.84,45.83 L24.84,41.27 L17.39,41.27 L17.39,46.14 C15.309135,46.6725413 13.3524424,47.6067262 11.63,48.89 L8.17,45.58 L3.09,51 L6.83,54.46 C5.75121182,56.5381117 5.10807768,58.8146024 4.94,61.15 L0.34,61.75 L1.29,69.13 L6.1,68.51 C6.75946494,70.1500784 7.67408972,71.675578 8.81,73.03 L5.88,76.64 L11.68,81.3 L14.61,77.53 C16.2125148,78.2695647 17.9250537,78.7424551 19.68,78.93 L20.08,83.55 L27.49,82.91 L27.13,78.1 C28.783865,77.5151059 30.3359843,76.674937 31.73,75.61 L35.2,78.67 L40.11,73.08 L36.46,69.87 C37.2684702,68.3071011 37.8253151,66.6264422 38.11,64.89 Z M21.39,68.53 C17.5626667,68.53 14.46,65.4273333 14.46,61.6 C14.46,57.7726667 17.5626667,54.67 21.39,54.67 C25.2173333,54.67 28.32,57.7726667 28.32,61.6 C28.3226591,63.4387642 27.5933901,65.2029822 26.2931862,66.5031862 C24.9929822,67.8033901 23.2287642,68.5326591 21.39,68.53 Z",
  id: "_Compound_Path_"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.58,44.62 L85.24,44.42 L84.93,37 L80.08,37.22 C79.5695412,35.5342388 78.7930936,33.9408333 77.78,32.5 L81,29.12 L75.61,23.92 L72.27,27.39 C70.7309167,26.5194619 69.0635562,25.8984207 67.33,25.55 L67.33,21 L59.89,21 L59.89,25.86 C57.8046997,26.3938643 55.8443618,27.3315649 54.12,28.62 L50.66,25.31 L45.6,30.76 L49.34,34.23 C48.2497131,36.2993501 47.6090495,38.5757507 47.46,40.91 L42.83,41.52 L43.83,48.89 L48.65,48.27 C49.2987531,49.9088772 50.2033223,51.434494 51.33,52.79 L48.42,56.41 L54.22,61.07 L57.22,57.36 C58.8194485,58.0983524 60.5284981,58.5712119 62.28,58.76 L62.68,63.39 L70.09,62.68 L69.66,57.84 C71.3218835,57.2593042 72.8812279,56.4188784 74.28,55.35 L77.74,58.42 L82.66,52.82 L79.01,49.62 C79.7978059,48.0482004 80.3278975,46.3600104 80.58,44.62 Z M63.89,48.25 C61.0861673,48.2499971 58.5586074,46.5604727 57.4865637,43.9696813 C56.4145199,41.3788899 57.0092565,38.3973903 58.9932966,36.4162132 C60.9773367,34.4350361 63.959692,33.8446056 66.5489326,34.9203894 C69.1381733,35.9961733 70.8240459,38.5261702 70.82,41.33 C70.8200019,43.167032 70.08956,44.9286783 68.7896447,46.2267179 C67.4897293,47.5247574 65.7270301,48.2526547 63.89,48.25 Z",
  id: "_Compound_Path_2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.19,22.73 L46.82,22.09 L45.82,14.71 L41.02,15.39 C40.3427195,13.7653637 39.4147731,12.257029 38.27,10.92 L41.14,7.26 L35.29,2.66 L32.29,6.49 C30.674864,5.77336099 28.9573312,5.31445243 27.2,5.13 L26.77,0.53 L19.36,1.26 L19.84,6.09 C17.811669,6.82011073 15.9463989,7.94131133 14.35,9.39 L10.51,6.45 L6,12.34 L10,15.44 C9.09928137,17.6319988 8.67982381,19.9918739 8.77,22.36 L4.2,23.36 L6,30.61 L10.73,29.52 C11.5425489,31.0839977 12.5991296,32.508525 13.86,33.74 L11.31,37.64 L17.5,41.78 L20.16,37.71 C21.8335155,38.2882317 23.5894951,38.5921513 25.36,38.61 L26.21,43.18 L33.5,41.78 L32.56,37 C34.1558517,36.2595704 35.6241072,35.2706075 36.91,34.07 L40.7,36.77 L45.03,30.77 L41.03,27.96 C41.7078431,26.2942471 42.1000054,24.5261361 42.19,22.73 Z M25.93,27.92 C23.141351,28.2087934 20.4534181,26.7889219 19.1200631,24.3227246 C17.7867082,21.8565272 18.0706383,18.8299116 19.8394062,16.6547277 C21.6081742,14.4795438 24.5132848,13.5843618 27.1995675,14.3867645 C29.8858502,15.1891672 31.8240346,17.5310596 32.11,20.32 L32.11,20.39 C32.470369,24.1721324 29.7097819,27.5357603 25.93,27.92 Z",
  id: "_Compound_Path_3"
}))));

var SvgManLaptopV1 = function SvgManLaptopV1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "429px",
    height: "362px",
    viewBox: "0 0 429 362",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManLaptopV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/man-laptop-v1.3cdf7897.svg";
export { ForwardRef as ReactComponent };